import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import MapboxAutocomplete from 'containers/mapbox/autocomplete';
import MapboxGeolocation from 'components/mapbox/geolocation';
import CoordinatesModel from 'models/coordinates';

import HubModel from 'models/hub';
import Brand from 'models/brand';
import Insights from '@parkwhiz-js/insights-sdk';
import * as AppContext from 'lib/app-context';
import MonthlyToggle from 'containers/mapbox/autocomplete/monthly-toggle';

const propTypes = {
  geoIPLocation: PropTypes.instanceOf(CoordinatesModel).isRequired,
  hub: PropTypes.instanceOf(HubModel).isRequired,
  appContext: PropTypes.string,
  insights: PropTypes.instanceOf(Insights).isRequired,
  trackEvent: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
  appContext: AppContext.DESKTOP,
};

class HeroSearch extends Component {
  constructor(props) {
    super(props);

    this.toggleMonthlySearch = this.toggleMonthlySearch.bind(this);
    this.heroImage = this.heroImage.bind(this);

    // TODO: Remove, deprecated?
    this.state = {
      monthly: false,
    };
  }

  // TODO: Remove, deprecated?
  toggleMonthlySearch() {
    this.setState({ monthly: !this.state.monthly });
  }

  heroImage() {
    const { hub } = this.props;

    if (hub.heroClass === 'minor-hub') { return null; }

    return (`/images/city-maps/${hub.heroClass}@2x.png`);
  }

  render() {
    const { hub, geoIPLocation, appContext, brand } = this.props;

    // TODO: Remove, deprecated?
    let additionalQueryParams = {};
    if (this.state.monthly) {
      additionalQueryParams = {
        monthly: 1,
      };
    }

    const isBestParking = brand.isBestParking;
    const backgroundClassName = cx({
      'background-color-watermelon': !isBestParking,
      'background-color-bp-dark-blue': isBestParking,
    });

    return (
      <div className={`hero-search background-image-infini-p-main ${backgroundClassName}`}>
        <div className="container text-center-lte-sm">
          <div className="row">
            <div className="col-md-8 col-xs-12">
              <div className="row">
                <div className="col-md-8 col-xs-6 col-xs-offset-3 col-md-offset-0 logo-container">
                  <a href="/"><img src={brand.logoDarkURL} alt={brand.displayName} /></a>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-12">
                      <h1 className="h1-sg white text-weight-bold with-top-margin text-left-gte-md uppercase">
                        {`${hub.name} Parking`}
                      </h1>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <h2 className="h2-sg white text-left-gte-md with-vertical-margin-half">Find the best space at the lowest rate.</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8 text-left-gte-md with-vertical-margin-half">
                  <MonthlyToggle />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 text-center text-left-gte-md">
                  <div className="input-group cta-hero-input with-map-pin-icon">
                    <MapboxAutocomplete
                      className="gplaces-autocomplete"
                      buttonClassName="btn btn-blue"
                      buttonText="FIND PARKING"
                      dropdownClassName="location-suggestion-bar-homepage"
                      inputClassName="form-control focusField gplaces-input-dropdown"
                      geoIPLocation={geoIPLocation}
                      placeholder={appContext === AppContext.MOBILE ? 'Search Place or Event' : 'Search Address, Place or Event'}
                      additionalQueryParams={additionalQueryParams}
                      trackEvent={this.props.trackEvent}
                      insights={this.props.insights}
                      app="Hub"
                      hub={hub}
                      id="hub-autocomplete"
                    />
                  </div>
                  <div className="form-group visible-xs text-center">
                    <MapboxGeolocation
                      buttonClassName="btn btn-clean btn-blue text-color-white progress-btn-background-blue find-parking-btn"
                      geoIPLocation={geoIPLocation}
                      hubPageUrl={hub.url}
                      insights={this.props.insights}
                    />
                  </div>
                  <div
                    className="checkbox checkbox-sg with-vertical-margin-2x-gte-md text-left centered-lte-sm monthly-search"
                    onClick={this.toggleMonthlySearch}
                  >
                    <input
                      id="only-show-monthly-search"
                      type="checkbox"
                      name="monthly"
                      checked={this.state.monthly}
                    />
                    <label className="text-weight-medium white" name="monthly">Only show monthly parking</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 city-map hidden-lte-sm">
              <Link to={{ pathname: `${hub.url}` }}>
                <picture>
                  <source media="(max-width: 991px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />
                  <img
                    alt={hub.name}
                    className="with-top-margin"
                    src={this.heroImage()}
                  />
                </picture>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HeroSearch.propTypes = propTypes;
HeroSearch.defaultProps = defaultProps;
export default HeroSearch;
